import { createTabsModule } from './features/tabs';

export const ozonMainTabs = createTabsModule({
  state: {
    tabs: [
      { name: 'Каталог', component: 'CatalogTabsMain', action: 'ozonCatalog/catalogList' },
      {
        name: 'Продавцы',
        component: 'SellerMain',
      },
      {
        name: 'Ключевики',
        component: 'TagMain',
        icon: 'mdi-lock-outline',
        disabled: true,
      },
      // {
      //   name: 'Поиск товаров',
      //   component: 'SearchMain',
      // },
    ],
    tab: 0,
  },
});
